import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const [themeMode, setThemeMode] = useState('device'); // 'device' | 'dark' | 'light'

  useEffect(() => {
    const storedMode = localStorage.getItem('themeMode') || 'device';
    applyTheme(storedMode);
  }, []);

  useEffect(() => {
    if (themeMode !== 'device') return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleSystemThemeChange = () => applyTheme('device');

    mediaQuery.addEventListener('change', handleSystemThemeChange);
    return () => mediaQuery.removeEventListener('change', handleSystemThemeChange);
  }, [themeMode]);

  const applyTheme = (mode) => {
    let actualTheme = mode;

    if (mode === 'device') {
      actualTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    if (actualTheme === 'dark') {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

    setTheme(actualTheme);
    setThemeMode(mode);
    localStorage.setItem('themeMode', mode);
  };

  const setThemeModeDirectly = (mode) => {
    applyTheme(mode);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeMode, setThemeModeDirectly }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

